import { put, takeLatest } from 'redux-saga/effects';

import { config } from '@/config/config';
import { logger } from '@/config/logger';
import { api } from '@/modules/api/fetcher';
import { actions as messagesActions } from '@/modules/messages';
import { AccessRole } from '@/types';

import { SharingPermission } from '../../constants';
import type { Settings } from '../../types';
import { loadSettings, loadSettingsFailure, loadSettingsSuccess } from '../actions';

const prepareSettings = (
    settings: Omit<Settings, 'sharingPermission' | 'defaultPermission'> &
        Partial<Pick<Settings, 'sharingPermission' | 'defaultPermission'>>,
): Settings => ({
    sharingPermission: SharingPermission.DISALLOWED,
    defaultPermission: AccessRole.VIEWER,
    ...settings,
});

function* fetchSettings() {
    try {
        const { data } = yield* api().get<Settings>(config.api.settings);

        yield put(loadSettingsSuccess(prepareSettings(data)));
    } catch (e) {
        yield put(loadSettingsFailure(e));

        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'error.settings.load' },
                options: {
                    duration: 5,
                },
            }),
        );
        logger.error(e);
    }
}

export function* loadSettingsSaga() {
    yield takeLatest(loadSettings.toString(), fetchSettings);
}
